import gsap from 'gsap'
import Draggable from 'gsap/Draggable'

gsap.registerPlugin(Draggable)

const draggableInit = () => {
    let mm = gsap.matchMedia()

    mm.add('(max-width: 767px)', () => {
        // console.log("Draggable enabled for mobile") // Debugging

        const DRAGGABLE_ELEMENTS = document.querySelectorAll('.draggable')

        if (DRAGGABLE_ELEMENTS.length === 0) return

        DRAGGABLE_ELEMENTS.forEach((element) => {
            Draggable.create(element, {
                type: 'x',
                bounds: element.closest('[data-location-map]'),
                zIndexBoost: false,
            })
        })
    })
}

export default draggableInit
